/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetMissionsParams,
  MissionCreateInput,
  MissionExtended,
  MissionShip,
  MissionShipCreateInput,
  MissionShipUpdateInput,
  MissionSlot,
  MissionSlotCreateInput,
  MissionSlotSortInput,
  MissionSlotUpdateInput,
  MissionTeam,
  MissionTeamCreateInput,
  MissionTeamUpdateInput,
  MissionUpdateInput,
  MissionsList,
  SchemaValidationErrorResponse,
  SortInput,
  StandardError,
  SuccessResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Mission
 */
export const createFleetMission = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionCreateInput: MaybeRefOrGetter<MissionCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionCreateInput = toValue(missionCreateInput);

      return axiosClient<MissionExtended>(
      {url: `/fleets/${fleetSlug}/missions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: missionCreateInput, signal
    },
      );
    }




export const getCreateFleetMissionMutationKey = () => ['createFleetMission'] as const;

export const getCreateFleetMissionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetMission>>, TError,CreateFleetMissionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetMission>>, TError,CreateFleetMissionMutationVariables, TContext> => {

const mutationKey = getCreateFleetMissionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetMission>>, CreateFleetMissionMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetMission(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetMissionMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetMission>>>
    export type CreateFleetMissionMutationBody = MissionCreateInput
    export type CreateFleetMissionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateFleetMissionMutationVariables = {fleetSlug: string;data: MissionCreateInput}

    /**
 * @summary Create Mission
 */
export const useCreateFleetMission = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetMission>>, TError,CreateFleetMissionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetMission>>,
        TError,
        CreateFleetMissionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetMissionMutationOptions(options), queryClient);
    }
    /**
 * @summary List Missions
 */
export const fleetMissions = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMissionsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<MissionsList>(
      {url: `/fleets/${fleetSlug}/missions`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetMissionsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMissionsParams>,) => {
    return [
    'fleets',fleetSlug,'missions', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetMissionsQueryOptions = <TData = Awaited<ReturnType<typeof fleetMissions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMissionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMissions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMissionsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMissions>>> = ({ signal }) => fleetMissions(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMissions>>, TError, TData>
}

export type FleetMissionsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMissions>>>
export type FleetMissionsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Missions
 */

export function useFleetMissions<TData = Awaited<ReturnType<typeof fleetMissions>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetMissionsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMissions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMissionsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Mission Team
 */
export const createMissionTeam = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    missionTeamCreateInput: MaybeRefOrGetter<MissionTeamCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
missionTeamCreateInput = toValue(missionTeamCreateInput);

      return axiosClient<MissionTeam>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: missionTeamCreateInput, signal
    },
      );
    }




export const getCreateMissionTeamMutationKey = () => ['createMissionTeam'] as const;

export const getCreateMissionTeamMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMissionTeam>>, TError,CreateMissionTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMissionTeam>>, TError,CreateMissionTeamMutationVariables, TContext> => {

const mutationKey = getCreateMissionTeamMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMissionTeam>>, CreateMissionTeamMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,data} = props ?? {};

          return  createMissionTeam(fleetSlug,missionSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMissionTeamMutationResult = NonNullable<Awaited<ReturnType<typeof createMissionTeam>>>
    export type CreateMissionTeamMutationBody = MissionTeamCreateInput
    export type CreateMissionTeamMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateMissionTeamMutationVariables = {fleetSlug: string;missionSlug: string;data: MissionTeamCreateInput}

    /**
 * @summary Create Mission Team
 */
export const useCreateMissionTeam = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMissionTeam>>, TError,CreateMissionTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMissionTeam>>,
        TError,
        CreateMissionTeamMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMissionTeamMutationOptions(options), queryClient);
    }
    /**
 * @summary Sort Mission Teams
 */
export const sortMissionTeams = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    sortInput: MaybeRefOrGetter<SortInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
sortInput = toValue(sortInput);

      return axiosClient<SuccessResponse>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sortInput, signal
    },
      );
    }




export const getSortMissionTeamsMutationKey = () => ['sortMissionTeams'] as const;

export const getSortMissionTeamsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortMissionTeams>>, TError,SortMissionTeamsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sortMissionTeams>>, TError,SortMissionTeamsMutationVariables, TContext> => {

const mutationKey = getSortMissionTeamsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortMissionTeams>>, SortMissionTeamsMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,data} = props ?? {};

          return  sortMissionTeams(fleetSlug,missionSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SortMissionTeamsMutationResult = NonNullable<Awaited<ReturnType<typeof sortMissionTeams>>>
    export type SortMissionTeamsMutationBody = SortInput
    export type SortMissionTeamsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SortMissionTeamsMutationVariables = {fleetSlug: string;missionSlug: string;data: SortInput}

    /**
 * @summary Sort Mission Teams
 */
export const useSortMissionTeams = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortMissionTeams>>, TError,SortMissionTeamsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sortMissionTeams>>,
        TError,
        SortMissionTeamsMutationVariables,
        TContext
      > => {
      return useMutation(getSortMissionTeamsMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Mission Team
 */
export const destroyMissionTeam = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyMissionTeamMutationKey = () => ['destroyMissionTeam'] as const;

export const getDestroyMissionTeamMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMissionTeam>>, TError,DestroyMissionTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyMissionTeam>>, TError,DestroyMissionTeamMutationVariables, TContext> => {

const mutationKey = getDestroyMissionTeamMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyMissionTeam>>, DestroyMissionTeamMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,id} = props ?? {};

          return  destroyMissionTeam(fleetSlug,missionSlug,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyMissionTeamMutationResult = NonNullable<Awaited<ReturnType<typeof destroyMissionTeam>>>

    export type DestroyMissionTeamMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyMissionTeamMutationVariables = {fleetSlug: string;missionSlug: string;id: string}

    /**
 * @summary Destroy Mission Team
 */
export const useDestroyMissionTeam = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMissionTeam>>, TError,DestroyMissionTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyMissionTeam>>,
        TError,
        DestroyMissionTeamMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyMissionTeamMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Mission Team
 */
export const updateMissionTeam = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    missionTeamUpdateInput: MaybeRefOrGetter<MissionTeamUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
id = toValue(id);
missionTeamUpdateInput = toValue(missionTeamUpdateInput);

      return axiosClient<MissionTeam>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: missionTeamUpdateInput, signal
    },
      );
    }




export const getUpdateMissionTeamMutationKey = () => ['updateMissionTeam'] as const;

export const getUpdateMissionTeamMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMissionTeam>>, TError,UpdateMissionTeamMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateMissionTeam>>, TError,UpdateMissionTeamMutationVariables, TContext> => {

const mutationKey = getUpdateMissionTeamMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMissionTeam>>, UpdateMissionTeamMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,id,data} = props ?? {};

          return  updateMissionTeam(fleetSlug,missionSlug,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMissionTeamMutationResult = NonNullable<Awaited<ReturnType<typeof updateMissionTeam>>>
    export type UpdateMissionTeamMutationBody = MissionTeamUpdateInput
    export type UpdateMissionTeamMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateMissionTeamMutationVariables = {fleetSlug: string;missionSlug: string;id: string;data: MissionTeamUpdateInput}

    /**
 * @summary Update Mission Team
 */
export const useUpdateMissionTeam = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMissionTeam>>, TError,UpdateMissionTeamMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateMissionTeam>>,
        TError,
        UpdateMissionTeamMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMissionTeamMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Mission Ship
 */
export const createMissionShip = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    missionTeamId: MaybeRefOrGetter<string>,
    missionShipCreateInput: MaybeRefOrGetter<MissionShipCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
missionTeamId = toValue(missionTeamId);
missionShipCreateInput = toValue(missionShipCreateInput);

      return axiosClient<MissionShip>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams/${missionTeamId}/ships`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: missionShipCreateInput, signal
    },
      );
    }




export const getCreateMissionShipMutationKey = () => ['createMissionShip'] as const;

export const getCreateMissionShipMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMissionShip>>, TError,CreateMissionShipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMissionShip>>, TError,CreateMissionShipMutationVariables, TContext> => {

const mutationKey = getCreateMissionShipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMissionShip>>, CreateMissionShipMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,missionTeamId,data} = props ?? {};

          return  createMissionShip(fleetSlug,missionSlug,missionTeamId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMissionShipMutationResult = NonNullable<Awaited<ReturnType<typeof createMissionShip>>>
    export type CreateMissionShipMutationBody = MissionShipCreateInput
    export type CreateMissionShipMutationError = ErrorType<ValidationError | StandardError>
    export type CreateMissionShipMutationVariables = {fleetSlug: string;missionSlug: string;missionTeamId: string;data: MissionShipCreateInput}

    /**
 * @summary Create Mission Ship
 */
export const useCreateMissionShip = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMissionShip>>, TError,CreateMissionShipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMissionShip>>,
        TError,
        CreateMissionShipMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMissionShipMutationOptions(options), queryClient);
    }
    /**
 * @summary Sort Mission Ships
 */
export const sortMissionShips = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    missionTeamId: MaybeRefOrGetter<string>,
    sortInput: MaybeRefOrGetter<SortInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
missionTeamId = toValue(missionTeamId);
sortInput = toValue(sortInput);

      return axiosClient<SuccessResponse>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams/${missionTeamId}/ships/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sortInput, signal
    },
      );
    }




export const getSortMissionShipsMutationKey = () => ['sortMissionShips'] as const;

export const getSortMissionShipsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortMissionShips>>, TError,SortMissionShipsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sortMissionShips>>, TError,SortMissionShipsMutationVariables, TContext> => {

const mutationKey = getSortMissionShipsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortMissionShips>>, SortMissionShipsMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,missionTeamId,data} = props ?? {};

          return  sortMissionShips(fleetSlug,missionSlug,missionTeamId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SortMissionShipsMutationResult = NonNullable<Awaited<ReturnType<typeof sortMissionShips>>>
    export type SortMissionShipsMutationBody = SortInput
    export type SortMissionShipsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SortMissionShipsMutationVariables = {fleetSlug: string;missionSlug: string;missionTeamId: string;data: SortInput}

    /**
 * @summary Sort Mission Ships
 */
export const useSortMissionShips = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortMissionShips>>, TError,SortMissionShipsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sortMissionShips>>,
        TError,
        SortMissionShipsMutationVariables,
        TContext
      > => {
      return useMutation(getSortMissionShipsMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Mission Ship
 */
export const destroyMissionShip = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    missionTeamId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
missionTeamId = toValue(missionTeamId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams/${missionTeamId}/ships/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyMissionShipMutationKey = () => ['destroyMissionShip'] as const;

export const getDestroyMissionShipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMissionShip>>, TError,DestroyMissionShipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyMissionShip>>, TError,DestroyMissionShipMutationVariables, TContext> => {

const mutationKey = getDestroyMissionShipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyMissionShip>>, DestroyMissionShipMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,missionTeamId,id} = props ?? {};

          return  destroyMissionShip(fleetSlug,missionSlug,missionTeamId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyMissionShipMutationResult = NonNullable<Awaited<ReturnType<typeof destroyMissionShip>>>

    export type DestroyMissionShipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyMissionShipMutationVariables = {fleetSlug: string;missionSlug: string;missionTeamId: string;id: string}

    /**
 * @summary Destroy Mission Ship
 */
export const useDestroyMissionShip = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMissionShip>>, TError,DestroyMissionShipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyMissionShip>>,
        TError,
        DestroyMissionShipMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyMissionShipMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Mission Ship
 */
export const updateMissionShip = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    missionTeamId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    missionShipUpdateInput: MaybeRefOrGetter<MissionShipUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
missionTeamId = toValue(missionTeamId);
id = toValue(id);
missionShipUpdateInput = toValue(missionShipUpdateInput);

      return axiosClient<MissionShip>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams/${missionTeamId}/ships/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: missionShipUpdateInput, signal
    },
      );
    }




export const getUpdateMissionShipMutationKey = () => ['updateMissionShip'] as const;

export const getUpdateMissionShipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMissionShip>>, TError,UpdateMissionShipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateMissionShip>>, TError,UpdateMissionShipMutationVariables, TContext> => {

const mutationKey = getUpdateMissionShipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMissionShip>>, UpdateMissionShipMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,missionTeamId,id,data} = props ?? {};

          return  updateMissionShip(fleetSlug,missionSlug,missionTeamId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMissionShipMutationResult = NonNullable<Awaited<ReturnType<typeof updateMissionShip>>>
    export type UpdateMissionShipMutationBody = MissionShipUpdateInput
    export type UpdateMissionShipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateMissionShipMutationVariables = {fleetSlug: string;missionSlug: string;missionTeamId: string;id: string;data: MissionShipUpdateInput}

    /**
 * @summary Update Mission Ship
 */
export const useUpdateMissionShip = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMissionShip>>, TError,UpdateMissionShipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateMissionShip>>,
        TError,
        UpdateMissionShipMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMissionShipMutationOptions(options), queryClient);
    }
    /**
 * @summary Duplicate Mission Ship
 */
export const duplicateMissionShip = (
    fleetSlug: MaybeRefOrGetter<string>,
    missionSlug: MaybeRefOrGetter<string>,
    missionTeamId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
missionSlug = toValue(missionSlug);
missionTeamId = toValue(missionTeamId);
id = toValue(id);

      return axiosClient<MissionShip>(
      {url: `/fleets/${fleetSlug}/missions/${missionSlug}/teams/${missionTeamId}/ships/${id}/duplicate`, method: 'POST', signal
    },
      );
    }




export const getDuplicateMissionShipMutationKey = () => ['duplicateMissionShip'] as const;

export const getDuplicateMissionShipMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateMissionShip>>, TError,DuplicateMissionShipMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof duplicateMissionShip>>, TError,DuplicateMissionShipMutationVariables, TContext> => {

const mutationKey = getDuplicateMissionShipMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof duplicateMissionShip>>, DuplicateMissionShipMutationVariables> = (props) => {
          const {fleetSlug,missionSlug,missionTeamId,id} = props ?? {};

          return  duplicateMissionShip(fleetSlug,missionSlug,missionTeamId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DuplicateMissionShipMutationResult = NonNullable<Awaited<ReturnType<typeof duplicateMissionShip>>>

    export type DuplicateMissionShipMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DuplicateMissionShipMutationVariables = {fleetSlug: string;missionSlug: string;missionTeamId: string;id: string}

    /**
 * @summary Duplicate Mission Ship
 */
export const useDuplicateMissionShip = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof duplicateMissionShip>>, TError,DuplicateMissionShipMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof duplicateMissionShip>>,
        TError,
        DuplicateMissionShipMutationVariables,
        TContext
      > => {
      return useMutation(getDuplicateMissionShipMutationOptions(options), queryClient);
    }
    /**
 * @summary Archive Mission
 */
export const destroyFleetMission = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<MissionExtended | void>(
      {url: `/fleets/${fleetSlug}/missions/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetMissionMutationKey = () => ['destroyFleetMission'] as const;

export const getDestroyFleetMissionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMission>>, TError,DestroyFleetMissionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMission>>, TError,DestroyFleetMissionMutationVariables, TContext> => {

const mutationKey = getDestroyFleetMissionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetMission>>, DestroyFleetMissionMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  destroyFleetMission(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetMissionMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetMission>>>

    export type DestroyFleetMissionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetMissionMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Archive Mission
 */
export const useDestroyFleetMission = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetMission>>, TError,DestroyFleetMissionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetMission>>,
        TError,
        DestroyFleetMissionMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetMissionMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Mission
 */
export const fleetMission = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<MissionExtended>(
      {url: `/fleets/${fleetSlug}/missions/${slug}`, method: 'GET', signal
    },
      );
    }




export const getFleetMissionQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,) => {
    return [
    'fleets',fleetSlug,'missions',slug
    ] as const;
    }


export const getFleetMissionQueryOptions = <TData = Awaited<ReturnType<typeof fleetMission>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMission>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetMissionQueryKey(fleetSlug,slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetMission>>> = ({ signal }) => fleetMission(fleetSlug,slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetMission>>, TError, TData>
}

export type FleetMissionQueryResult = NonNullable<Awaited<ReturnType<typeof fleetMission>>>
export type FleetMissionQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show Mission
 */

export function useFleetMission<TData = Awaited<ReturnType<typeof fleetMission>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetMission>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetMissionQueryOptions(fleetSlug,slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Mission
 */
export const updateFleetMission = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    missionUpdateInput: MaybeRefOrGetter<MissionUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
missionUpdateInput = toValue(missionUpdateInput);

      return axiosClient<MissionExtended>(
      {url: `/fleets/${fleetSlug}/missions/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: missionUpdateInput, signal
    },
      );
    }




export const getUpdateFleetMissionMutationKey = () => ['updateFleetMission'] as const;

export const getUpdateFleetMissionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetMission>>, TError,UpdateFleetMissionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetMission>>, TError,UpdateFleetMissionMutationVariables, TContext> => {

const mutationKey = getUpdateFleetMissionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetMission>>, UpdateFleetMissionMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  updateFleetMission(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetMissionMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetMission>>>
    export type UpdateFleetMissionMutationBody = MissionUpdateInput
    export type UpdateFleetMissionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetMissionMutationVariables = {fleetSlug: string;slug: string;data: MissionUpdateInput}

    /**
 * @summary Update Mission
 */
export const useUpdateFleetMission = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetMission>>, TError,UpdateFleetMissionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetMission>>,
        TError,
        UpdateFleetMissionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetMissionMutationOptions(options), queryClient);
    }
    /**
 * @summary Unarchive Mission
 */
export const unarchiveFleetMission = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<MissionExtended>(
      {url: `/fleets/${fleetSlug}/missions/${slug}/unarchive`, method: 'PUT', signal
    },
      );
    }




export const getUnarchiveFleetMissionMutationKey = () => ['unarchiveFleetMission'] as const;

export const getUnarchiveFleetMissionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetMission>>, TError,UnarchiveFleetMissionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetMission>>, TError,UnarchiveFleetMissionMutationVariables, TContext> => {

const mutationKey = getUnarchiveFleetMissionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveFleetMission>>, UnarchiveFleetMissionMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  unarchiveFleetMission(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveFleetMissionMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveFleetMission>>>

    export type UnarchiveFleetMissionMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnarchiveFleetMissionMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Unarchive Mission
 */
export const useUnarchiveFleetMission = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetMission>>, TError,UnarchiveFleetMissionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unarchiveFleetMission>>,
        TError,
        UnarchiveFleetMissionMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveFleetMissionMutationOptions(options), queryClient);
    }
    /**
 * @summary Create Mission Slot
 */
export const createMissionSlot = (
    missionSlotCreateInput: MaybeRefOrGetter<MissionSlotCreateInput>,
 signal?: AbortSignal
) => {
      missionSlotCreateInput = toValue(missionSlotCreateInput);

      return axiosClient<MissionSlot>(
      {url: `/mission-slots`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: missionSlotCreateInput, signal
    },
      );
    }




export const getCreateMissionSlotMutationKey = () => ['createMissionSlot'] as const;

export const getCreateMissionSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMissionSlot>>, TError,CreateMissionSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createMissionSlot>>, TError,CreateMissionSlotMutationVariables, TContext> => {

const mutationKey = getCreateMissionSlotMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createMissionSlot>>, CreateMissionSlotMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createMissionSlot(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateMissionSlotMutationResult = NonNullable<Awaited<ReturnType<typeof createMissionSlot>>>
    export type CreateMissionSlotMutationBody = MissionSlotCreateInput
    export type CreateMissionSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateMissionSlotMutationVariables = {data: MissionSlotCreateInput}

    /**
 * @summary Create Mission Slot
 */
export const useCreateMissionSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createMissionSlot>>, TError,CreateMissionSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createMissionSlot>>,
        TError,
        CreateMissionSlotMutationVariables,
        TContext
      > => {
      return useMutation(getCreateMissionSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Sort Mission Slots
 */
export const sortMissionSlots = (
    missionSlotSortInput: MaybeRefOrGetter<MissionSlotSortInput>,
 signal?: AbortSignal
) => {
      missionSlotSortInput = toValue(missionSlotSortInput);

      return axiosClient<SuccessResponse>(
      {url: `/mission-slots/sort`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: missionSlotSortInput, signal
    },
      );
    }




export const getSortMissionSlotsMutationKey = () => ['sortMissionSlots'] as const;

export const getSortMissionSlotsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortMissionSlots>>, TError,SortMissionSlotsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof sortMissionSlots>>, TError,SortMissionSlotsMutationVariables, TContext> => {

const mutationKey = getSortMissionSlotsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof sortMissionSlots>>, SortMissionSlotsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  sortMissionSlots(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SortMissionSlotsMutationResult = NonNullable<Awaited<ReturnType<typeof sortMissionSlots>>>
    export type SortMissionSlotsMutationBody = MissionSlotSortInput
    export type SortMissionSlotsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SortMissionSlotsMutationVariables = {data: MissionSlotSortInput}

    /**
 * @summary Sort Mission Slots
 */
export const useSortMissionSlots = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof sortMissionSlots>>, TError,SortMissionSlotsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof sortMissionSlots>>,
        TError,
        SortMissionSlotsMutationVariables,
        TContext
      > => {
      return useMutation(getSortMissionSlotsMutationOptions(options), queryClient);
    }
    /**
 * @summary Destroy Mission Slot
 */
export const destroyMissionSlot = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/mission-slots/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyMissionSlotMutationKey = () => ['destroyMissionSlot'] as const;

export const getDestroyMissionSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMissionSlot>>, TError,DestroyMissionSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyMissionSlot>>, TError,DestroyMissionSlotMutationVariables, TContext> => {

const mutationKey = getDestroyMissionSlotMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyMissionSlot>>, DestroyMissionSlotMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  destroyMissionSlot(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyMissionSlotMutationResult = NonNullable<Awaited<ReturnType<typeof destroyMissionSlot>>>

    export type DestroyMissionSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyMissionSlotMutationVariables = {id: string}

    /**
 * @summary Destroy Mission Slot
 */
export const useDestroyMissionSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyMissionSlot>>, TError,DestroyMissionSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyMissionSlot>>,
        TError,
        DestroyMissionSlotMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyMissionSlotMutationOptions(options), queryClient);
    }
    /**
 * @summary Update Mission Slot
 */
export const updateMissionSlot = (
    id: MaybeRefOrGetter<string>,
    missionSlotUpdateInput: MaybeRefOrGetter<MissionSlotUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
missionSlotUpdateInput = toValue(missionSlotUpdateInput);

      return axiosClient<MissionSlot>(
      {url: `/mission-slots/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: missionSlotUpdateInput, signal
    },
      );
    }




export const getUpdateMissionSlotMutationKey = () => ['updateMissionSlot'] as const;

export const getUpdateMissionSlotMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMissionSlot>>, TError,UpdateMissionSlotMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateMissionSlot>>, TError,UpdateMissionSlotMutationVariables, TContext> => {

const mutationKey = getUpdateMissionSlotMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateMissionSlot>>, UpdateMissionSlotMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateMissionSlot(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateMissionSlotMutationResult = NonNullable<Awaited<ReturnType<typeof updateMissionSlot>>>
    export type UpdateMissionSlotMutationBody = MissionSlotUpdateInput
    export type UpdateMissionSlotMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateMissionSlotMutationVariables = {id: string;data: MissionSlotUpdateInput}

    /**
 * @summary Update Mission Slot
 */
export const useUpdateMissionSlot = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateMissionSlot>>, TError,UpdateMissionSlotMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateMissionSlot>>,
        TError,
        UpdateMissionSlotMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateMissionSlotMutationOptions(options), queryClient);
    }
